export default __webpack_public_path__ + "static/media/Boots of Berserker's Fury.b791c973.jpg";